import { isProductAccessible, userCan } from "@/lib/utils";
import notification from "element-ui/packages/notification";

const Onboarding = () => import("@/pages/products/authx/onboarding");

const Base = () => import("@/pages/products/authx/base");
const Index = () => import("@/pages/products/authx/index");
const Plan = () => import("@/pages/products/authx/plan");

const Create = () => import("@/pages/products/authx/application/create");
const Overview = () => import("@/pages/products/authx/application/overview");
const Configuration = () =>
  import("@/pages/products/authx/application/configuration");
const Integration = () =>
  import("@/pages/products/authx/application/integration");
const Users = () => import("@/pages/products/authx/application/users");
const Logs = () => import("@/pages/products/authx/application/logs");

const Preview = () =>
  import("@/pages/products/authx/application/preview/index");
const Redirect = () =>
  import("@/pages/products/authx/application/preview/redirect.vue");

let checkRoutePermissions = (to, from, next, action = "app.getall") => {
  const allowRouteView = userCan("authx", action);
  const allowAdmin = userCan("auth", "feature.saveorganisationfeature");

  let title = "";
  let message = "";

  if (isProductAccessible("authx")) {
    if (allowRouteView) {
      next();
    } else {
      next({ name: "home.index" });
      title = "Access Denied";
      message = "You are not authorized to view this page";
    }
  } else {
    if (allowAdmin) {
      next({ name: "authx.onboarding" });
    } else {
      next({ name: "home.index" });
      title = "Access Denied";
      message = "Organisation has no access. Contact admin";
    }
  }

  if (title) {
    notification({
      title,
      message,
      duration: 5000,
      customClass: "error"
    });
  }
};

const routes = () => {
  return [
    {
      path: "/authx/",
      component: Base,
      redirect: {
        name: "authx.index"
      },
      meta: {
        requiresAuth: true,
        layout: "app",
        childLayout: "product",
        label: "AuthX"
      },
      children: [
        {
          path: "onboarding",
          name: "authx.onboarding",
          component: Onboarding,
          meta: {
            requiresAuth: true,
            layout: "app",
            label: "Onboarding"
          }
        },
        {
          path: "overview",
          name: "authx.index",
          component: Index,
          meta: {
            requiresAuth: true,
            layout: "app",
            childLayout: "product",
            label: "Applications"
          },
          beforeEnter: (to, from, next) => {
            checkRoutePermissions(to, from, next, "app.getall");
          }
        },
        {
          path: "apps/create",
          name: "authx.apps.create",
          component: Create,
          meta: {
            requiresAuth: true,
            layout: "app",
            childLayout: "product",
            label: "Create Application"
          },
          beforeEnter: (to, from, next) => {
            checkRoutePermissions(to, from, next, "app.create");
          }
        },
        {
          path: "apps/:id/",
          component: Base,
          redirect: {
            name: "authx.apps.overview"
          },
          meta: {
            requiresAuth: true,
            label: "Applications"
          },
          children: [
            {
              path: "overview",
              name: "authx.apps.overview",
              component: Overview,
              meta: {
                requiresAuth: true,
                layout: "app",
                childLayout: "authx-app",
                label: "Overview"
              },
              beforeEnter: (to, from, next) => {
                checkRoutePermissions(to, from, next, "app.getone");
              }
            },
            {
              path: "configuration",
              name: "authx.apps.configuration",
              component: Configuration,
              meta: {
                requiresAuth: true,
                layout: "app",
                childLayout: "authx-app",
                label: "Configuration"
              },
              beforeEnter: (to, from, next) => {
                checkRoutePermissions(to, from, next, "app.updatedata");
              }
            },
            {
              path: "integration",
              name: "authx.apps.integration",
              component: Integration,
              meta: {
                requiresAuth: true,
                layout: "app",
                childLayout: "authx-app",
                label: "Integration"
              },
              beforeEnter: (to, from, next) => {
                checkRoutePermissions(to, from, next, "app.getone");
              }
            },
            {
              path: "users",
              name: "authx.apps.users",
              component: Users,
              meta: {
                requiresAuth: true,
                layout: "app",
                childLayout: "authx-app",
                label: "Users Management"
              },
              beforeEnter: (to, from, next) => {
                checkRoutePermissions(to, from, next, "user.getall");
              }
            },
            {
              path: "logs",
              name: "authx.apps.logs",
              component: Logs,
              meta: {
                requiresAuth: true,
                layout: "app",
                childLayout: "authx-app",
                label: "Logs"
              },
              beforeEnter: (to, from, next) => {
                checkRoutePermissions(to, from, next, "app.getone");
              }
            }
          ]
        },
        {
          path: "plan",
          name: "authx.plan",
          component: Plan,
          meta: {
            requiresAuth: true,
            requiresAccountVerification: true,
            layout: "app",
            childLayout: "product",
            label: "Plan"
          },
          beforeEnter: (to, from, next) => {
            checkRoutePermissions(to, from, next);
          }
        },
      ]
    },
    {
      path: "/authx/:id/preview",
      name: "authx.preview.index",
      component: Preview,
      meta: {
        requiresAuth: false,
        label: "Preview"
      }
      // beforeEnter: (to, from, next) => {
      //   checkRoutePermissions(to, from, next, "app.preview");
      // }
    },
    {
      path: "/authx/:id/redirect",
      name: "authx.preview.redirect",
      component: Redirect,
      meta: {
        requiresAuth: false,
        label: "Preview Redirect"
      }
      // beforeEnter: (to, from, next) => {
      //   checkRoutePermissions(to, from, next, "app.preview");
      // }
    }
  ];
};

export default routes();
